import {
    ANALYSTS, DATA, DELTA, DELTA_OPTION_SELECT, ENTERPRISE, LEADERSHIP, NONE, SECONDARY_NAV_NEXT_CLICK,
    SECONDARY_NAV_PREVIOUS_CLICK, TARGET, TECHNIQUES,
    TECHNOLOGY
} from '../constants';
import { filter, includes } from 'lodash';

export interface SelectedOptions {
    [DELTA_OPTIONS: string]: string;
}

export interface DeltaReducerState {
    isValid: boolean;
    activePanel: string;
    selectedOptions: SelectedOptions;
}

interface OptionSelectPayload {
    option: string;
    id: string;
    deltaId: string;
    navId: string;
}

interface Action {
    type: string;
    payload: OptionSelectPayload;
}

const initialState = {
    isValid: false,
    activePanel: DATA,
    selectedOptions: {
        [DATA]: NONE,
        [ENTERPRISE]: NONE,
        [LEADERSHIP]: NONE,
        [TARGET]: NONE,
        [ANALYSTS]: NONE,
        [TECHNOLOGY]: NONE,
        [TECHNIQUES]: NONE
    }
};

const selections = [
    DATA, ENTERPRISE, LEADERSHIP, TARGET, ANALYSTS, TECHNOLOGY, TECHNIQUES
];

function updateSelectedOptions(state: DeltaReducerState, id: string, option: string) {
    state.selectedOptions[id] = option;

    return {
        ...state
    };
}

function getNextActivePanel(id: string) {
    switch (id) {
        case DATA:
            return ENTERPRISE;
        case ENTERPRISE:
            return LEADERSHIP;
        case LEADERSHIP:
            return TARGET;
        case TARGET:
            return ANALYSTS;
        case ANALYSTS:
            return TECHNOLOGY;
        case TECHNOLOGY:
            return TECHNIQUES;
        default:
            return id;
    }
}

function getPriorActivePanel(id: string) {
    switch (id) {
        case ENTERPRISE:
            return DATA;
        case LEADERSHIP:
            return ENTERPRISE;
        case TARGET:
            return LEADERSHIP;
        case ANALYSTS:
            return TARGET;
        case TECHNOLOGY:
            return ANALYSTS;
        case TECHNIQUES:
            return TECHNOLOGY;
        default:
            return id;
    }
}

function updateActivePanel(state: DeltaReducerState, id: string) {
    state.activePanel = id;

    return {
        ...state
    };
}

function getSelectionsThatNeedValidation(selectedOptions: SelectedOptions) {
    return filter(selectedOptions, (item, key): boolean => includes(selections, key));
}

function isDeltaValid(selectedOptions: SelectedOptions) {
    const selectionsToValidate = getSelectionsThatNeedValidation(selectedOptions);
    const invalid = filter(selectionsToValidate, (item) => item === NONE);

    return invalid.length < 1;
}

function isActiveSection(navId?: string) {
    return navId === DELTA;
}

const deltaReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case DELTA_OPTION_SELECT:
            const newState = updateSelectedOptions(state, action.payload.id, action.payload.option);
            const isValid = isDeltaValid(state.selectedOptions);

            return {
                ...state,
                ...newState,
                isValid
            };
        case SECONDARY_NAV_NEXT_CLICK:
            if (isActiveSection(action.payload.navId)) {
                return {
                    ...state,
                    ...updateActivePanel(state, getNextActivePanel(action.payload.deltaId))
                };
            }

            return {
                ...state
            };
        case SECONDARY_NAV_PREVIOUS_CLICK:
            return {
                ...state,
                ...updateActivePanel(state, getPriorActivePanel(action.payload.deltaId))
            };
        default:
            return {
                ...state
            };
    }
};

export default deltaReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/reducers/deltaReducer.ts